import { GridColDef } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react'
import { DateFormatter } from '../../../../shared/utils/DateFormatter';
import { CommonFunctions } from '../../../../shared/utils/CommonFunctions';
import { AppConfigurationHelper } from '../../../../services/AppConfigurationHelper';
import { useDispatch, useSelector } from 'react-redux';
import useGet from '../../../../services/hooks/useGet';
import { hideLoader, showLoader } from '../../../../store/currentPreferencesSlice';
import { Heading } from '../../../../shared/ReusableComponents';
import { apiEndpoints } from '../../../../shared/constants/api-constant';
import { GridTable } from '../../../../shared/ReusableComponents/GridTable';
import { Box } from '@mui/material';
import { Button } from '../../../../shared/ReusableComponents';
import { IFrequency, IMedication } from '../PrescribedMedication/types';
import OneTimeMedicationModal from './OneTimeMedicationModal';
import { MedicationHistory } from '../PrescribedMedication/MedicationHistory';
import { caseRepository } from '../../../../services/caseRepository';
import { OnceOnlyMedicine } from '../../../../shared/constants/enums';
import moment from 'moment';

interface IOneTimeMedication {
    caseId: number;
    contraindicated: boolean | null;
    dose: string;
    frequency: IFrequency[];
    frequencyName: string;
    id: number;
    indication: string;
    isVariable: boolean;
    maxPRN: string;
    medicineName: string;
    medicineType: string;
    prescribedby: string;
    prophylaxis: boolean | null;
    route: string;
    startDate: string | null;
    vteAssessed: boolean | null;
    administerOn?: string | null;
    initials?: string;
    counterSignedBy?: string;
    isAdminister?: boolean;
}


const commonCellStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
};

function OneTimeMedication({ caseId }: { caseId: number }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedMedication, setSelectedMedication] = useState<IOneTimeMedication | null>(null);
    const [medicationHistoryData, setMedicationHistoryData] = useState<any>([]);

    const auth = useSelector((state: any) => state.login);

    const handleAdministerClick = (medication: IOneTimeMedication) => {
        setSelectedMedication(medication);
        setIsModalOpen(true);
    };

    const columns: GridColDef[] = [
        // {
        //     field: "startDate",
        //     headerName: "Date, Time",
        //     width: 160,
        //     sortable: true,
        //     valueGetter: (value, row) =>

        //         `${DateFormatter.formatDate(value)}, ${DateFormatter.formatTime(
        //             row.startDate
        //         )}`,
        // },
        {
            field: "medicineName",
            headerName: "Medicine",
            sortable: true,
            width: 120,
            valueGetter: (value, row) => row.medicineName,
        },
          {
            field: "scheduledDate",
            headerName: "Scheduled Date",
            valueGetter: (value, row) => {
                let startDate = moment.utc(row?.startDate).local();
                if(startDate.isBefore(moment())){
                    return startDate.format("DD/MM/YYYY")

                }
            }

        },
        {
            field: "scheduledTime",
            headerName: "Scheduled Time",
            valueGetter: (value, row) => {
                return row?.frequency?.[0]?.schedule || "-";
            }

        },
        {
            field: "route",
            headerName: "Route",
            valueGetter: (value, row) => {
                return row.route;
            }
        },
        {
            field: "dose",
            headerName: "Dose",
            valueGetter: (value, row) => row.dose,
        },
        {
            field: "indication",
            headerName: "Indication",
            valueGetter: (value, row) => row.indication,
        },
        // {
        //     field: "administeredOn",
        //     headerName: "Administerd on",
        //     valueGetter: (value, row) =>{
        //         console.log("=====row",row)
        //         return medicationHistoryData.find((el: any) => el.scheduleTimeId === row.frequency[0].doseDetails.id)?.schedule || '-';
        //     } 



        // },

        {
            field: "counterSignedBy",
            headerName: "Counter Signed By",
            valueGetter: (value, row) => {
                const name = row.frequency[0].doseDetails.counterSignedBy;
                const displayName = CommonFunctions.getDisplayValue(name);
                return displayName ===
                    AppConfigurationHelper.Instance().displayDefaults?.emptyFallback
                    ? displayName
                    : CommonFunctions.formatName(displayName, { suffixKey: "rn" });
            },
        },
      
        
        {
            field: "isAdminister",
            headerName: "Action",
            width: 120,
            renderCell: (params) => {
                const history = medicationHistoryData.find((el: any) => el.scheduleTimeId === params?.row?.frequency[0]?.doseDetails?.id);
                const { isGiven } = params.row.frequency[0];
                const dose = history?.dose || params.row.dose;
                const dateTime = `${DateFormatter.formatDate(
                    params.row.frequency[0].doseDetails?.updatedOn
                )}, ${history?.schedule?.substring(0,5)}`;
                const message = `${dateTime} ${dose} Administered by ${params.row.initials} (SN)`;
                return isGiven ? (
                    <span title={message}>{message}</span>
                ) : (
                    <Box sx={{ ...commonCellStyle }}>
                        <Button
                            id="administer"
                            onClick={() => handleAdministerClick(params.row)}
                            text="Administer"
                            className="tinyBtn"
                            style={{
                                color: "var(--color-white)",
                                textTransform: "capitalize",
                                width: "90px",
                                p: "0px 40px",
                            }}
                        />
                    </Box>
                );
            },
        },
    ];

    const [originalData, setOriginalData] = useState<IOneTimeMedication[]>([]);

    const dispatch = useDispatch();
    const {
        data: getData,
        getService: getApiCall,
        loading: getLoading,
    } = useGet();

    useEffect(() => {
        getLoading && dispatch(showLoader());
        !getLoading && dispatch(hideLoader());
    }, [getLoading]);

    useEffect(() => {
        getLoading && dispatch(showLoader());
        if (!(getData && originalData)) {
            getApiCall(`${apiEndpoints.MEDICATIONS}/${caseId}`);
        }
    }, [caseId]);

    useEffect(() => {

        dispatch(showLoader());
        caseRepository
            .GetMedicationHistory(caseId)
            .then((result: any) => {
                const res = [...result];
                const filteredResult = res.filter(
                    (item) => item.medicineType === "Once Only"
                );
                setMedicationHistoryData(filteredResult);
            })
            .finally(() => {
                dispatch(hideLoader());
            });

    }, [originalData])



    useEffect(() => {
        if (getData?.length > 0) {
            const result = getData
                .filter(
                    (item: IOneTimeMedication) =>
                        typeof item.medicineType === "string" &&
                        item.medicineType.toLowerCase() === "once only" &&
                        item.startDate &&
                             moment.utc(item.startDate).local().isSame(moment(), 'day')
                        
                )
                .map((item: IOneTimeMedication) => ({
                    ...item,
                    initials: CommonFunctions.formatFirstAndLastName(auth?.userInfo?.userFirstName, auth?.userInfo?.userLastName)
                }));
            setOriginalData(result);
            dispatch(hideLoader());
        }
    }, [getData]);

    return (
        <div>
            <Box className="d-flex justify-between mb-1">

                <Heading type="h5" isBold={true} text={OnceOnlyMedicine} />


            </Box>

            <React.Fragment>
                <GridTable
                    rows={originalData}
                    columns={columns}
                    pageSizeOptions={[5, 10, 15]}
                    initialPageSize={10}
                    showSearchBar={false}
                />
                {isModalOpen && selectedMedication && (
                    <OneTimeMedicationModal
                        open={isModalOpen}
                        onClose={() => setIsModalOpen(false)}
                        medication={selectedMedication}
                        onSubmit={() => getApiCall(`${apiEndpoints.MEDICATIONS}/${caseId}`)}
                    />
                )}
            </React.Fragment>

        </div>
    );
}

export default OneTimeMedication;
